"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
var _util = require("../../../util");
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".pf-page-disclosure {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0;\n  gap: 10px;\n  color: #557b92;\n  width: 343px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 32px;\n}\n@media (min-width: 320px) {\n  .pf-page-disclosure {\n    font-family: \"Neue Haas Grotesk Text Regular\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-page-disclosure {\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n@media (min-width: 768px) {\n  .pf-page-disclosure {\n    width: 704px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-page-disclosure {\n    width: 960px;\n  }\n}\n@media (min-width: 1280px) {\n  .pf-page-disclosure {\n    width: 1216px;\n  }\n}\n.pf-page-disclosure__item {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0;\n  gap: 2px;\n}\n.pf-page-disclosure .pf-page-disclosure__superscript {\n  font-weight: 700;\n  font-size: 8px;\n  line-height: 8px;\n  margin-right: 8px;\n  top: 0;\n}\n.pf-page-disclosure__description {\n  font-size: 12px;\n  line-height: 16px;\n}\n.pf-page-disclosure__heading {\n  font-weight: 700;\n}\n.pf-page-disclosure__footnote {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}";
  var fileName = "disclosure__styles_a8671179-ab0d-4a80-861c-0e12f058732a";
  var element = document.querySelector("style[data-sass-component='disclosure__styles_a8671179-ab0d-4a80-861c-0e12f058732a']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-page-disclosure';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Disclosure = function Disclosure(_ref) {
  var heading = _ref.heading,
    description = _ref.description,
    superscript = _ref.superscript;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('item')
  }, /*#__PURE__*/_react.default.createElement(_base.default, {
    className: bem('superscript'),
    as: "sup"
  }, superscript), /*#__PURE__*/_react.default.createElement(_base.default, {
    className: bem('description')
  }, /*#__PURE__*/_react.default.createElement(_base.default, {
    as: "span",
    className: bem('heading')
  }, heading), description));
};
Disclosure.propTypes = {
  heading: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  superscript: _propTypes.default.string
};
Disclosure.defaultProps = {
  superscript: ''
};
var _default = exports.default = Disclosure;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');